import { useCallback } from 'react';

interface SelectOption<T> {
    value: T | undefined | null | boolean | '';
    label: string | number | boolean;
}

interface SelectProps<T> {
    value: T;
    onChange: (value: T) => void;
    options: SelectOption<T>[];
    className?: string;
}

const Select = <T extends string | number | boolean | undefined>({
    value,
    onChange,
    options,
    className
}: SelectProps<T>) => {
    const handleChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = options.find(opt => String(opt.value) === e.target.value)?.value;
        if (selectedValue !== undefined) {
            onChange(selectedValue);
        }
    }, [onChange, options]);

    return (
        <select
            value={String(value)}
            onChange={handleChange}
            className={`px-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg focus:outline-none focus:ring focus:ring-blue-500 dark:focus:ring-blue-400 transition-colors ${className || ''}`}
        >
            {options.map((option) => (
                <option key={String(option.value)} value={String(option.value)}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Select;